import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box
} from "@material-ui/core";
import { TablaHistorialEmp } from "./Menus/TablaHistorialEmp";
import { getTrackingEnviosNosConecta, getTrackingEnviosScienza, getTrackingSolicitudEmp } from "../../../actions/empadronamiento/Empadronamiento";
import { EMPADRONAMIENTO_MENU_HISTORIAL } from "../../../utils/constants";
import PropTypes from "prop-types";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const ModalHistorialCambiosEmp = (props) => {
  const dispatch = useDispatch();
  const { open } = props;

  const { trackingSolicitudEmp, trackingScienza, trackingNosConecta } = useSelector((state) => state.empadronamiento);
  const [selectedTab, setSelectedTab] = useState(
    EMPADRONAMIENTO_MENU_HISTORIAL.SOLICITUD
  );
  useEffect(() => {
    dispatch(getTrackingSolicitudEmp(props.solicitud?.idSolicitud));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getTrackingEnviosScienza(props.solicitud?.idSolicitud, null));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getTrackingEnviosNosConecta(props.solicitud?.idSolicitud, null));
  }, [dispatch]);

  return (
    <Dialog
      fullWidth
      maxWidth={
        selectedTab === EMPADRONAMIENTO_MENU_HISTORIAL.SOLICITUD ? "md" : "lg"
      }
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>Historial de Cambios - {props.titulo}</DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            label="Solicitud"
            {...a11yProps(EMPADRONAMIENTO_MENU_HISTORIAL.SOLICITUD)}
          />
          <Tab
            label="Envio Mandataria"
            {...a11yProps(EMPADRONAMIENTO_MENU_HISTORIAL.ENVIOS)}
          />
          <Tab
            label="Envio Archivos (NosConecta)"
            {...a11yProps(EMPADRONAMIENTO_MENU_HISTORIAL.NOSCONECTA)}
          />
        </Tabs>

        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_HISTORIAL.SOLICITUD}
        >
          <TablaHistorialEmp datos={trackingSolicitudEmp} idMenu={selectedTab} />
        </TabPanel>

        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_HISTORIAL.ENVIOS}
        >
          <TablaHistorialEmp datos={trackingScienza} idMenu={selectedTab} />
        </TabPanel>

        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_HISTORIAL.NOSCONECTA}
        >
          <TablaHistorialEmp datos={trackingNosConecta} idMenu={selectedTab} />
        </TabPanel>


      </DialogContent>
    </Dialog>
  );
};
